import { useState, useCallback } from 'react';

export function useFilePreview() {
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string>('');

  const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (!selected) return;

    setFile(selected);
    const reader = new FileReader();
    reader.onload = (event) => {
      setPreview(event.target?.result as string);
    };
    reader.readAsDataURL(selected);

    e.target.value = '';
  }, []);

  const clear = useCallback(() => {
    setFile(null);
    setPreview('');
  }, []);

  return { file, preview, handleFileSelect, clear };
}
